// with ES6 import
import { io } from 'socket.io-client';
import { getAuthHeader } from 'utils/auth';
import store from '../ducks/configureStore';
import { fetchNotifications } from '../ducks/modules/notifications';
import Initialiser from 'initialiser';

class SocketClient {
    constructor() {
        this.socket = null;
    }
    connect() {
        this.socket = io('/', {
            path: '/api/socket',
            transports: ['websocket', 'polling'],
            extraHeaders: { Authorization: getAuthHeader() },
            withCredentials: true,
        });

        this.socket.on('connect', () => {
            const url = Initialiser.history.location.pathname;
            if (!url.includes('/forms/')) {
                store.dispatch(fetchNotifications(false, 10, true));
            }
        });

        this.socket.on('connect_error', () => {
            const url = Initialiser.history.location.pathname;
            if (!url.includes('/forms/')) {
                store.dispatch(fetchNotifications(false, 10, true));
            }
        });

        this.socket.on('fetch', () => {
            // NOTE: We could receive here the data related to the notification, but if some is lost we may risk misalignment
            store.dispatch(fetchNotifications(true));
        });
    }
}

export default new SocketClient();
